/**
 *
 * @param {TrackingAnalytics} analytics
 * @constructor
 */
function IndexTracker(analytics) {
    'use strict';

    this.analytics = analytics;
}

IndexTracker.prototype = {
    init: function () {
        'use strict';

        const config = type => (
            {
                eventName: 'Home Page Search Form',
                eventBody: {
                    event_category: 'Search',
                    event_label: type,
                    value: 1
                }

            });
        this.initSearchTracking(
            '#dimensions-size', config('By Size')
        );
        this.initSearchTracking(
            '#dimensions-brand',
            config('By Brand')
        );
        this.initSearchTracking(
            '#dimensions-vehicle',
            config('By Vehicle')
        );

        this.initEcommerceTracking();
    },

    /**
 * @param {String} container
 * @param {Array} config
 */
    initSearchTracking: function (container, config) {
        'use strict';

        var $container = $(container),
            $form = $container.find('form');

        $container.find('form button').on(
            'click',
            $.proxy(
                function (ev) {
                    ev.preventDefault();

                    this.analytics.setCustomVariable(1, config[2]);

                    this.analytics.trackWithCallback(
                        config,
                        $.proxy($form.submit, $form)
                    );
                },
                this
            )
        );
    },

    /**
     * @param {String} container
     * @param {Array} config
     * @return {IndexTracker}
     */
    initEcommerceTracking: function () {
        'use strict';

        $('.carousel__item').on('click', this.trackPromoClick.bind(this));
        return this;
    },

    /**
     * Add promo ecommerce tracking
     */
    trackPromoClick: function () {
        'use strict';
        this.analytics.setEcommerceAction('promo_click', window.GADATA.promotions['promo_savings']);
    }
};

export default IndexTracker;